import environment from "web/script/modules/environment";

export function getURL(patternName) {
    return environment.get("urlPatterns")[patternName];
}
